export default "__VITE_ASSET__17867f2e__"